


























































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import router from "../../router";
import { Getter } from "vuex-class";
import { Equipment } from "../../models";
import { getImageUrl, formatDate } from "../../utilities";

@Component
export default class Report extends Vue {
  private getImageUrl = getImageUrl;
  private item: any = null;
  @Getter inventory;
  @Getter statuses;

  private formatDate = formatDate;

  async print() {
    window.print();
  }

  private reports = [
    { text: "Sales Sheet", id: 0 },
    { text: "Inventory", id: 1 },
    { text: "Financials Sheet", id: 2 },
    { text: "Final Sheet", id: 3 },
  ];

  get allStatuses() {
    const results = [{ text: "All" }];
    this.statuses.forEach((x) => {
      results.push(x);
    });
    return results;
  }
  get allStockNumbers() {
    return this.inventory.map((x) => x.stockNumber).sort();
  }

  get testReportSpecs() {
    return [
      { text: "Year", value: this.item.year },
      { text: "Make", value: this.item.make },
      { text: "Model", value: this.item.model },
      { text: "VIN", value: this.item.vin },
      { text: "Series", value: this.item.series },
      { text: "GVWR", value: this.item.gvwr },
      { text: "Class", value: this.item.gvwrClass },
      {
        text: "Odometer",
        value: Number(this.item.odometer).toLocaleString() + " mi",
      },
    ];
  }

  private inventoryReportHeaders = [
    { text: "Image", value: "image" },
    { text: "Name", value: "name" },
    { text: "Stock #", value: "stockNumber" },
    { text: "Price", value: "price" },
  ];

  get inventoryReportFiltered(): Array<Equipment> {
    return this.inventory.filter((x) => {
      //if Visible dont filter on category
      if (this.data.selectedStatus == "All") {
        return true;
      } else {
        return x.status.text == this.data.selectedStatus;
      }
    });
  }

  private localStorageName = "report-data";
  private data = {
    selectedReport: 0,
    selectedStockNumber: "",
    selectedStatus: "All",
  };

  async created() {
    // Open Storage
    const result = JSON.parse(
      localStorage.getItem(this.localStorageName) || "{}"
    );
    const fields = ["selectedReport", "selectedStockNumber", "selectedStatus"];
    fields.forEach((x) => {
      if (result[x]) {
        this.data[x] = result[x];
      }
    });

    const stockNumber = this.$route.query.stockNumber;
    if (stockNumber != undefined) {
      if (Array.isArray(stockNumber)) {
        if (stockNumber.length > 0 && stockNumber[0] != null) {
          this.data.selectedStockNumber = stockNumber[0];
        }
      } else {
        this.data.selectedStockNumber = stockNumber;
      }
    }
  }

  async save() {
    localStorage.setItem(this.localStorageName, JSON.stringify(this.data));
  }

  back() {
    router.back();
  }

  @Watch("inventory", { immediate: true })
  inventoryUpdated() {
    if (Array.isArray(this.inventory)) {
      const result = this.inventory.filter(
        (x) => x.stockNumber == this.data.selectedStockNumber
      )[0];
      this.item = result;
    }
  }

  @Watch("data.selectedStockNumber")
  selectedStockNumberUpdated() {
    if (Array.isArray(this.inventory)) {
      const result = this.inventory.filter(
        (x) => x.stockNumber == this.data.selectedStockNumber
      )[0];
      this.item = result;
    }
    this.$router.replace({
      name: "report",
      query: { stockNumber: this.data.selectedStockNumber },
    });
  }
}
